/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Organize_IntroInputs */

const en_pc_tut_organize_intro = /** @type {(inputs: Pc_Tut_Organize_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize pages shows every page at once, and every change can be undone.`)
};

const zh_pc_tut_organize_intro = /** @type {(inputs: Pc_Tut_Organize_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「Organize pages」一次展示所有页面，每个改动都可以撤销。`)
};

/**
* | output |
* | --- |
* | "Organize pages shows every page at once, and every change can be undone." |
*
* @param {Pc_Tut_Organize_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_organize_intro = /** @type {((inputs?: Pc_Tut_Organize_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Organize_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_organize_intro(inputs)
	return zh_pc_tut_organize_intro(inputs)
});
export { pc_tut_organize_intro as "pc.tut.organize.intro" }